// extracted by mini-css-extract-plugin
module.exports =  {"label":"_0bc5e8de02--label--ZJs9L","icon":"_0bc5e8de02--icon--gFV9a","title":"_0bc5e8de02--title--LeqmQ","clickable":"_0bc5e8de02--clickable--jctkV"};